import React from "react";
import "./Terms_Conditions.css";
import About_Banner_Component from "../about_us/about_banner/About_Banner_Component/About_Banner_Component";
import Terms_Conditions_content from "./Terms_Conditions_content/Terms_Conditions_content";

function Terms_Conditions() {
  return (
    <>
      <section className="Terms_Conditions">
        <About_Banner_Component
          img="\assets\Image\FAQ\banner.png"
          title="Terms & Conditions"
          showBtn={false}
        />

        <Terms_Conditions_content />
      </section>
    </>
  );
}

export default Terms_Conditions;
